import React from 'react';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Table, Tag } from 'antd';

import { COLUMN_LARGE, PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { debounce, formatDate } from 'utils';
import { renderWithTooltip } from 'utils/table';

function PromoTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
  onSearch,
}) {
  const columns = [
    {
      width: COLUMN_LARGE,
      title: 'Наименование компании',
      dataIndex: 'company',
      key: 'company',
      filterDropdown: ({ selectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по компании"
              value={selectedKeys[0]}
              onChange={debounce(onSearch, 800)}
              onMouseLeave={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      render: (value) => renderWithTooltip(value),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.company?.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Тип',
      dataIndex: 'type',
      key: 'type',
      render: (type) => (
        <Tag color="#108ee9">
          {type === 'unique' ? 'Уникальный' : 'Универсальный'}
        </Tag>
      ),
      filters: [
        {
          text: 'Уникальные',
          value: 'unique',
        },
        {
          text: 'Универсальные',
          value: 'universal',
        },
      ],
      onFilter: (value, record) => record.type === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Скидка (%)',
      dataIndex: 'percentage',
      key: 'percentage',
    },
    {
      title: 'Лимит',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: 'Статус',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <Tag color={isActive ? 'green' : 'red'}>
          {isActive ? 'Активный' : 'Не активный'}
        </Tag>
      ),
      filters: [
        {
          text: 'Активные',
          value: true,
        },
        {
          text: 'Не активные',
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Дата начала',
      dataIndex: 'start_date',
      key: 'start_date',
      render: (value) => formatDate(value),
    },
    {
      title: 'Дата окончания',
      dataIndex: 'end_date',
      key: 'end_date',
      render: (value) => formatDate(value),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      tableLayout="fixed"
      pagination={{
        current,
        total: totalRows,
        showSizeChanger: true,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { PromoTable };
